export function IconTwitter(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.553 19.88c9.046 0 13.995-7.493 13.995-13.995 0-.214 0-.427-.015-.64.96-.7 1.797-1.568 2.467-2.543a9.861 9.861 0 01-2.833.761A4.906 4.906 0 0023.33.753a9.684 9.684 0 01-3.122 1.188A4.907 4.907 0 0016.614.387a4.917 4.917 0 00-4.919 4.919c0 .38.046.761.122 1.127A13.981 13.981 0 011.675 1.286a4.881 4.881 0 00-.67 2.482c0 1.705.868 3.213 2.193 4.096A4.953 4.953 0 01.975 7.24v.06a4.92 4.92 0 003.944 4.828 5.201 5.201 0 01-1.295.168 6.2 6.2 0 01-.929-.076 4.928 4.928 0 004.6 3.41 9.851 9.851 0 01-6.107 2.102c-.411 0-.792-.015-1.188-.06a13.9 13.9 0 007.553 2.208z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  );
}
